export default class UpdateTypingStatus {
  constructor(context) {
    this.context = context;
  }

  run({ typingState, customerId }) {
    this.context.gateways.chatTyping.updateTypingStatus({ customerId, typingState });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/update_typing_status.js